import React, { useEffect, useState } from "react";
import "./datatable.scss";
import { Space, Input, Button, message, Form, Select, Collapse } from "antd";
import { useNavigate } from "react-router-dom";
import { Checkbox } from "antd";
import { Popover } from "antd";
import { EditOutlined, CheckOutlined, CheckCircleOutlined } from "@ant-design/icons";
import type { ColumnsType } from "antd/es/table";
import { authSVC } from "../../../services";
import { useB2BContext } from "../../../context/ContextB2B";
import CheckboxList from "./CheckboxList";
import CheckboxListP2 from "./CheckboxListP2";
import { TelephonoCodes } from "../../../utils/Constants";
import moment from "moment";
import { AppModal, AppTable } from "../../common";
const { Option } = Select;
const { Panel } = Collapse;
interface Contentdata {
  payment: any;
  key?: string;
  _id: string;
  bodyText: string;
  user_id: string;
  video_id: string;
  email: string;
  full_name: string;
  company: string;
  package_name: string;
  company_id: any;
  userId:string;
}

type PackagePricing = {
  packageAmount: number;
  igstTax: number;
  cgstTax: number;
  sgstTax: number;
  subTotalAmount: string; // or number if you don't use toFixed()
};

export interface ModuleChild {
  _id: string;
  moduleCode: string;
  label: string;
  category: string;
  allowAccess: boolean;
  child: ModuleChild[];
}

export interface ModuleAccess {
  module_id: string;
  enable: boolean | undefined;
}

export interface ModulesData {
  modules: ModuleChild[];
}

export interface CheckboxListProps {
  items: string[]; // The list of items for checkboxes
  preSelected?: string[]; // Optional list of pre-selected items
}

function CommentsDataTable({ deleteComments, contentData, refreshClients }: any) {
  const {
    setAllPackageList,
    allPackageList,
    selectedModulesList,
    selectedModulesListP2,
  } = useB2BContext();
  const [form] = Form.useForm();
  const [clientForm] = Form.useForm();
  const [searchText, setSearchText] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenClients, SetisModalOpenClients] = useState(false);
  const navigate = useNavigate();
  const [userId, setUserId] = useState<any>();
  const [userData, setUserData] = useState<any>();
  const { getUserByID } = useB2BContext();
  const [btnDisable, setBtnDisable] = useState(true);
  const [memberModules, setMemberModules] = useState<any>([]);
  const [packageId, setPackageId] = useState<any>("");
  const [packageIdP2, setPackageIdP2] = useState<any>("");
  const [companyId, setCompanyId] = useState<any>();
  const [preSelectPackages, setPreSelectPackages] = useState<any>([]);
  const [preSelectPackagesP2, setPreSelectPackagesP2] = useState<any>([]);
  const [mapModuleAccessList, setMapModuleAccessList] = useState();
  const [mapModuleAccessListP2, setMapModuleAccessListP2] = useState();
  const [paymentDuration, setPaymentDuration] = useState("");
  const [paymentDurationP2, setPaymentDurationP2] = useState("");
  const [isAmount, setIsAmount] = useState<any>(0);
  const [isAmount2, setIsAmount2] = useState<any>(0);
  const [isPricePerPerson, setPricePerPerson] = useState<any>(0);
  const [isPricePerPersonP2, setPricePerPersonP2] = useState<any>(0);
  const [isEmployees, setEmployees] = useState<any>(0);
  const [isEmployeesP2, setEmployeesP2] = useState<any>(0);
  const [packagePricingBreakdown, setPackagePricingBreakDown] = useState<any>(
    {}
  );
  console.log(contentData,"contentData");
  
  const [packagePricingBreakdown2, setPackagePricingBreakDown2] = useState<any>(
    {}
  );
  const [activeTab1, setActiveTab1] = useState<any>(false);
  const [activeTab2, setActiveTab2] = useState<any>(false);
  const [activeKey, setActiveKey] = useState<string | string[] | undefined>([
    "1",
  ]);
  const [anotherPlan, setAnotherPlan] = useState(false);
  const [defaultValueCode, setDefaultValueCode] = useState<any>();
  const [currencyCode, setCurrencyCode] = useState();
  const [countryCode, setCountryCode] = useState();
  const [isNextPackage, setIsNextPackage] = useState(true);
  const [disabledPacageDropdown, setDisabledPacageDropdown] = useState(false);

  const AssignAnotherPlan = () => {
    setActiveKey("2");
    setActiveTab2(true);
    setAnotherPlan(true);
  };

  useEffect(() => {
    console.log(
      isAmount,
      packageId,
      isEmployees,
      isPricePerPerson,
      paymentDuration,
      "alllll"
    );
    if (
      // isAmount !== 0 &&
      packageId !== "" &&
      isEmployees !== 0 &&
      isPricePerPerson !== "" &&
      paymentDuration !== ""
    ) {
      setIsNextPackage(false);
    }
  }, [isAmount, packageId, isEmployees, isPricePerPerson, paymentDuration]);

  useEffect(() => {
    console.log(
      packagePricingBreakdown.packageAmount,
      "packagePricingBreakdown"
    );
  }, [packagePricingBreakdown]);

  const onChangePricePerPerson = (e: any) => {
    const newPricePerPerson = Number(e.target.value);
    setPricePerPerson(newPricePerPerson);

    const isEmployeesNum = Number(isEmployees);
    const Package1Amount = newPricePerPerson * isEmployeesNum;

    const updatedPackagePricing: PackagePricing = {
      packageAmount: Package1Amount,
      igstTax: Package1Amount * 0.18,
      cgstTax: Package1Amount * 0.09,
      sgstTax: Package1Amount * 0.09,
      subTotalAmount: (Package1Amount + Package1Amount * 0.18).toFixed(2),
    };

    setPackagePricingBreakDown(updatedPackagePricing);
    setIsAmount(updatedPackagePricing.subTotalAmount);
  };
  const onChangePricePerPersonP2 = (e: any) => {
    const newPricePerPersonP2 = Number(e.target.value);
    setPricePerPersonP2(newPricePerPersonP2);

    const numEmployeesP2 = Number(isEmployeesP2) || 0;
    const packageAmount2 = newPricePerPersonP2 * numEmployeesP2;

    const updatedPackagePricing: PackagePricing = {
      packageAmount: packageAmount2,
      igstTax: packageAmount2 * 0.18,
      cgstTax: packageAmount2 * 0.09,
      sgstTax: packageAmount2 * 0.09,
      subTotalAmount: (packageAmount2 + packageAmount2 * 0.18).toFixed(2),
    };

    setPackagePricingBreakDown2(updatedPackagePricing);
    setIsAmount2(updatedPackagePricing.subTotalAmount);
  };

  const onChangeEmployees = (e: any) => {
    const newEmployees = Number(e.target.value);
    setEmployees(newEmployees);

    const isPricePerPersonNum = Number(isPricePerPerson);
    const Package1Amount = newEmployees * isPricePerPersonNum;

    const updatedPackagePricing: PackagePricing = {
      packageAmount: Package1Amount,
      igstTax: Package1Amount * 0.18,
      cgstTax: Package1Amount * 0.09,
      sgstTax: Package1Amount * 0.09,
      subTotalAmount: (Package1Amount + Package1Amount * 0.18).toFixed(2),
    };

    setPackagePricingBreakDown(updatedPackagePricing);
    setIsAmount(updatedPackagePricing.subTotalAmount);
  };

  const onChangeEmployeesP2 = (e: any) => {
    const newEmployees = Number(e.target.value);
    setEmployeesP2(newEmployees);

    const isPricePerPersonNum = Number(isPricePerPersonP2);
    const Package1Amount = newEmployees * isPricePerPersonNum;

    const updatedPackagePricing: PackagePricing = {
      packageAmount: Package1Amount,
      igstTax: Package1Amount * 0.18,
      cgstTax: Package1Amount * 0.09,
      sgstTax: Package1Amount * 0.09,
      subTotalAmount: (Package1Amount + Package1Amount * 0.18).toFixed(2),
    };

    setPackagePricingBreakDown2(updatedPackagePricing);
    setIsAmount2(updatedPackagePricing.subTotalAmount);
  };

  const handleChange = (value: string) => {
    setPackageId(value);
    form.setFieldsValue({
      package_price: "",
      employees: "",
      unitPrice: "",
      duration: "Select Duration",
    });
    setIsAmount(0);
    setPricePerPerson(0);
    setPackagePricingBreakDown({});
  };
  const handleChangeP2 = (value: string) => {
    setPackageIdP2(value);
    form.setFieldsValue({
      package_price_p2: "",
      employees_p2: "",
      unitPrice_p2: "",
      duration_p2: "Select Duration",
    });
    setIsAmount2(0);
    setPricePerPersonP2(0);
    setPackagePricingBreakDown2({});
  };

  const handleChangeDuration = (value: any) => {
    setPaymentDuration(value);
    console.log(value);
  };
  const handleChangeDurationP2 = (value: any) => {
    setPaymentDurationP2(value);
    console.log(value);
  };

  useEffect(() => {
    console.log(packagePricingBreakdown2, "1");
    console.log(packagePricingBreakdown, "2");
  }, [packagePricingBreakdown2, packagePricingBreakdown]);

  const VerifiedPackage = (event: any) => {
    if (event.target.checked === true) {
      setBtnDisable(false);
    } else {
      setBtnDisable(true);
    }
  };

  useEffect(() => {
    if (selectedModulesList && packageId) {
      let mapModuleAccess = [] as any;
      selectedModulesList.forEach((value: any) => {
        let tempPayload = {} as {
          package_id: string;
          module_id: string;
          enable: boolean;
        };
        tempPayload.package_id = packageId;
        tempPayload.module_id = value;
        tempPayload.enable = true;
        mapModuleAccess.push(tempPayload);
      });
      setMapModuleAccessList(mapModuleAccess);
    }
    if (selectedModulesListP2 && packageIdP2) {
      let mapModuleAccess2 = [] as any;
      selectedModulesListP2.forEach((value: any) => {
        let tempPayload = {} as {
          package_id: string;
          module_id: string;
          enable: boolean;
        };
        tempPayload.package_id = packageIdP2;
        tempPayload.module_id = value;
        tempPayload.enable = true;
        mapModuleAccess2.push(tempPayload);
      });
      setMapModuleAccessListP2(mapModuleAccess2);
    }
  }, [selectedModulesListP2, selectedModulesList, packageId, packageIdP2]);

  useEffect(() => {
    if (packageId && userData) {
      setTimeout(() => {
        authSVC
          .GetModules(userData?.company_id?._id, packageId)
          .then((res: any) => {
            setPreSelectPackages(res.data.pre_select_packages);
          })
          .catch((err: any) => {
            message.error(err.message);
          });
      }, 1000);
    }
    if (packageIdP2 && userData) {
      setTimeout(() => {
        authSVC
          .GetModules(userData?.company_id?._id, packageIdP2)
          .then((res: any) => {
            setPreSelectPackagesP2(res.data.pre_select_packages);
          })
          .catch((err: any) => {
            message.error(err.message);
          });
      }, 1000);
    }
  }, [packageId, userData, packageIdP2]);

  useEffect(() => {
    console.log(preSelectPackages, "preSelectPackages");
    console.log(preSelectPackagesP2, "preSelectPackagesP2");
  }, [preSelectPackages, preSelectPackagesP2]);

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
    setUserId(undefined);
    setUserData(undefined);
    setCompanyId(undefined);
    setPackageId("");
    setPackageIdP2("");
    setPreSelectPackages([]);
    setPreSelectPackagesP2([]);
    setMapModuleAccessList(undefined);
    setMapModuleAccessListP2(undefined);
    setPaymentDuration("");
    setPaymentDurationP2("");
    setIsAmount(0);
    setIsAmount2(0);
    setPricePerPerson(0);
    setPricePerPersonP2(0);
    setEmployees(0);
    setEmployeesP2(0);
    setPackagePricingBreakDown({});
    setPackagePricingBreakDown2({});
    setActiveTab1(false);
    setActiveTab2(false);
    setActiveKey(["1"]);
    setAnotherPlan(false);
    setDisabledPacageDropdown(false);
  };

  const handleOkClients = () => {
    SetisModalOpenClients(false);
  };

  const handleCancelClients = () => {
    SetisModalOpenClients(false);
    clientForm.resetFields();
  };

  useEffect(() => {
    console.log(isAmount, "isAmount");
  }, [isAmount]);

  const onFinish = (values: {
    package_name: string;
    package_name_p2: string;
    package_price: string;
    package_price_p2: string;
    unitPrice: string;
  }) => {
    let pkgDetails: any = {};
    pkgDetails = {
      company_id: userData.company_id?._id,
      addons: [
        values.package_name &&
          isAmount && {
            package: {
              package_id: values.package_name,
              price: isAmount,
              unit_price_per_employee: isPricePerPerson,
              total_unit_employee: isEmployees,
              package_duration: paymentDuration,
            },
            mapModuleAccess: mapModuleAccessList,
          },
        values.package_name_p2 &&
          isAmount && {
            package: {
              package_id: values.package_name_p2,
              price: isAmount2,
              unit_price_per_employee: isPricePerPersonP2,
              total_unit_employee: isEmployeesP2,
              package_duration: paymentDurationP2,
            },
            mapModuleAccess: mapModuleAccessListP2,
          },
      ].filter(Boolean), // Filter out undefined or null values
    };

    console.log(pkgDetails, "pkgDetails");

    authSVC
      .postMapModules(pkgDetails)
      .then((res: any) => {
        message.success("Payment Details Added");
        handleCancel();
        refreshClients?.();
      })
      .catch((err: any) => {
        message.error(err.message);
      });
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  const getUserData = async (uemail: string) => {
    authSVC
      .getByUEmail(uemail)
      .then((res: any) => {
        setUserData(res.data.data);
      })
      .catch((err: any) => {
        message.error(err.message);
      });
  };

  const AllModule = async () => {
    authSVC
      .getAllModule()
      .then((res: any) => {
        setMemberModules(res.data.modules);
      })
      .catch((err: any) => {
        message.error(err.message);
      });
  };

  const AllPackage = async () => {
    authSVC
      .getAllPackage()
      .then((res: any) => {
        setAllPackageList(res.data.package);
      })
      .catch((err: any) => {
        message.error(err.message);
      });
  };

  const addPaymentDetails = (
    vid: string,
    uemail: string,
    company_id: string
  ) => {
    setIsModalOpen(true);
    setUserId(vid);
    setCompanyId(company_id);
    getUserData(uemail);
    AllModule();
    AllPackage();
  };

  const findItemById = (id: any) => {
    return contentData.find((item: any) => item._id === id);
  };
  const AdminApprovePayment = (vid: string, email: string, record: any) => {
    const result = findItemById(vid);
    authSVC
      .approvePayment({
        user_id: result.payment[0]._id,
        company_id: result.payment[0]?.company_id?._id,
      })
      .then((res: any) => {
        getUserData(email);
        refreshClients?.();
        message.success("Payment Approved");
      })
      .catch((err: any) => {
        message.error(
          err.response?.data?.error ||
            err.response?.data?.message ||
            "Map module is not done for this account, please map module"
        );
      });
  };

  const viewPackageData01 = (
    data: any,
    vid: string,
    uemail: string,
    company_id: string
  ) => {
    setDisabledPacageDropdown(true);
    setActiveTab1(true);
    setActiveTab2(false);
    setActiveKey("1");
    setAnotherPlan(true);
    form.setFieldsValue({
      package_name: data?.package_id?._id,
      package_price: data?.price,
      employees: data?.total_unit_employee,
      unitPrice: data?.unit_price_per_employee,
      duration: data?.package_duration,
    });
    setPackageId(data?.package_id?._id);
    setPaymentDuration(data?.package_duration);
    addPaymentDetails(vid, uemail, company_id);
    setPricePerPerson(data?.unit_price_per_employee);
    setEmployees(data?.total_unit_employee);
    // setIsAmount(data?.price);

    const newPricePerPerson = Number(data?.unit_price_per_employee) || 0;
    const numEmployees = Number(data?.total_unit_employee) || 0;
    console.log(newPricePerPerson, numEmployees, "KKKKK");
    setPricePerPersonP2(newPricePerPerson);

    const packageAmount = newPricePerPerson * numEmployees;
    setIsAmount(packageAmount);

    if (packageAmount > 0) {
      const updatedPackagePricing: PackagePricing = {
        packageAmount: packageAmount,
        igstTax: packageAmount * 0.18,
        cgstTax: packageAmount * 0.09,
        sgstTax: packageAmount * 0.09,
        subTotalAmount: (packageAmount + packageAmount * 0.18).toFixed(2),
      };

      setPackagePricingBreakDown(updatedPackagePricing);
      setIsAmount(updatedPackagePricing.subTotalAmount);
    } else {
      setPackagePricingBreakDown2(null);
    }
  };

  const viewPackageData02 = (
    data: any,
    vid: string,
    uemail: string,
    company_id: string
  ) => {
    setDisabledPacageDropdown(true);
    setActiveKey("2");
    setActiveTab1(false);
    setActiveTab2(true);
    setAnotherPlan(true);
    form.setFieldsValue({
      package_name_p2: data?.package_id?._id,
      package_price_p2: data?.price,
      employees_p2: data?.total_unit_employee,
      unitPrice_p2: data?.unit_price_per_employee,
      duration_p2: data?.package_duration,
    });
    setPackageIdP2(data?.package_id?._id);
    setPaymentDurationP2(data?.package_duration);
    addPaymentDetails(vid, uemail, company_id);
    // setPricePerPerson(data?.unit_price_per_employee);
    // setEmployees(data?.total_unit_employee);
    // setIsAmount2(data?.price);

    // const newPricePerPersonP2 = Number(data?.unit_price_per_employee) || 0;
    // const numEmployeesP2 = Number(data?.total_unit_employee) || 0;

    // setPricePerPersonP2(newPricePerPersonP2);

    // const packageAmount2 = newPricePerPersonP2 * numEmployeesP2;
    // setIsAmount2(packageAmount2);

    // if (packageAmount2 > 0) {
    //   const updatedPackagePricing: PackagePricing = {
    //     packageAmount: packageAmount2,
    //     igstTax: packageAmount2 * 0.18,
    //     cgstTax: packageAmount2 * 0.09,
    //     sgstTax: packageAmount2 * 0.09,
    //     subTotalAmount: (packageAmount2 + packageAmount2 * 0.18).toFixed(2),
    //   };

    //   setPackagePricingBreakDown2(updatedPackagePricing);
    //   setIsAmount2(updatedPackagePricing.subTotalAmount);
    // } else {
    //   setPackagePricingBreakDown2(null);
    // }
  };

  const ArchiveCompany = (c_id: any) => {
    authSVC
      .ArchiveCompany({
        company_id: c_id,
      })
      .then((res: any) => {
        message.success(res.data.message);
        refreshClients?.();
      })
      .catch((err: any) => {
        message.error(err.response?.data?.error);
      });
  };

  const getArchiveList = () => {
    navigate("/archive");
  };

  const onFinishClients = (record: any) => {
    authSVC
      .addHruser({
        full_name: record.full_name,
        email: record.email,
        username: record.email,
        company: record.company,
        user_type: "Company_admin",
        phone_number: defaultValueCode + record.phone_number,
      })
      .then((res: any) => {
        if (res.data?.success === false) {
          message.error(res.data?.error || res.data?.message || "Failed to create company admin");
          return;
        }
        message.success("Added User Successfully");
        refreshClients?.();
        setTimeout(() => {
          handleCancelClients();
        }, 1000);
      })
      .catch((err: any) => {
        message.error(err.response?.data?.error || err.response?.data?.message || "Failed to create company admin");
      });
  };
  const nameValidation = (_: any, value: any) => {
    const regex = /^[A-Za-z\s]+$/;

    if (!value || regex.test(value)) {
      return Promise.resolve();
    }

    return Promise.reject(
      new Error("Please enter a valid name with only letters.")
    );
  };

  useEffect(() => {
    const url = "https://ipapi.co/json/";

    const fetchData = async () => {
      try {
        const response = await fetch(url);
        const json = await response.json();
        setCurrencyCode(json.currency);
        setCountryCode(json.country_code);
      } catch (error) {
        console.log("error", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    TelephonoCodes.map((item) => {
      if (item.code == countryCode) {
        setDefaultValueCode(item.phone);
      }
    });
  }, [countryCode, currencyCode]);

  const handleChangeCode = (value: string) => {
    console.log(`selected ${value}`);
    setDefaultValueCode(value);
  };

  const prefixSelector = defaultValueCode && (
    <Form.Item
      name="code"
      noStyle
      rules={[{ required: false, message: "Please Enter your phone code!" }]}
    >
      <Select
        defaultValue={defaultValueCode}
        style={{ width: 90 }}
        onChange={handleChangeCode}
        className="country_code_select"
        dropdownStyle={{ padding: "0px" }}
      >
        {TelephonoCodes.map((item) => {
          return (
            <Option value={item.phone} key={item.code}>
              {`+${item.phone}`}
            </Option>
          );
        })}
      </Select>
    </Form.Item>
  );

  const columns: ColumnsType<Contentdata> = [
    {
      title: "ID",
      dataIndex: "_id",
      key: "_id",
      width: 100,
      filteredValue: [searchText],
      render: (text) => <div className="truncate">{text}</div>,
      sorter: (a: any, b: any) => a._id.localeCompare(b._id),
      onFilter: (value, record) => {
        return (
          String(record.email).toLowerCase().includes(value.toLocaleString()) ||
          String(record.full_name)
            .toLowerCase()
            .includes(value.toLocaleString()) ||
          String(record._id).toLowerCase().includes(value.toLocaleString())
        );
      },
    },
    {
      title: "Business Name",
      width: 150,
      dataIndex: "company",
      key: "company",
    },
    {
      sorter: (a: any, b: any) => a.full_name.localeCompare(b.full_name),
      title: "Name",
      width: 150,
      dataIndex: "full_name",
      key: "full_name",
    },
    {
      title: "Company Email",
      dataIndex: "email",
      width: 250,
      key: "email",
    },
    {
      title: "Phone",
      dataIndex: "phone_number",
      width: 150,
      key: "phone_number",
      render: (text) => <div className="truncate">{text && `+${text}`}</div>,
    },
       {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => <div>{text && moment(text).format("DD-MM-YYYY hh:mm A")}</div>,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
            <Popover
              content={
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  <p
                    style={{
                      background: "#FFD800",
                      fontSize: "10px",
                      color: "#2E3191",
                      borderRadius: "8px",
                      padding: "8px",
                    }}
                  >
                    <strong>Please Note:</strong> <strong>Archiving</strong> a
                    client will immediately suspend their access to the platform
                    and deactivate their active membership.
                  </p>

                  {record?.payment[0]?.company_id?.package.length === 0 ? (
                    <Button
                      onClick={() => {
                        addPaymentDetails(
                          record._id,
                          record.userId,
                          record.company_id
                        );
                        setActiveTab1(true);
                      }}
                      style={{ backgroundColor: "#479751", color: "#fff" }}
                    >
                      Manage Package
                    </Button>
                  ) : (
                    <>
                      {record?.payment[0]?.company_id?.package.length === 1 && (
                        <Button
                          onClick={() =>
                            viewPackageData01(
                              record?.payment[0]?.company_id?.package[0],
                              record?._id,
                              record?.userId,
                              record?.payment[0]?.company_id?._id
                            )
                          }
                          style={{ backgroundColor: "#479751", color: "#fff" }}
                        >
                          Manage Package 1
                        </Button>
                      )}
                      {record?.payment[0]?.company_id?.package.length > 1 && (
                        <>
                          <Button
                            onClick={() =>
                              viewPackageData01(
                                record?.payment[0]?.company_id?.package[0],
                                record?._id,
                                record?.userId,
                                record?.payment[0]?.company_id?._id
                              )
                            }
                            style={{
                              backgroundColor: "#479751",
                              color: "#fff",
                            }}
                          >
                            Manage Package 1
                          </Button>
                          <Button
                            onClick={() =>
                              viewPackageData02(
                                record?.payment[0]?.company_id?.package[1],
                                record?._id,
                                record?.userId,
                                record?.payment[0]?.company_id?._id
                              )
                            }
                            style={{
                              backgroundColor: "#479751",
                              color: "#fff",
                            }}
                          >
                            Manage Package 2
                          </Button>{" "}
                        </>
                      )}
                    </>
                  )}

                  <Button
                    style={{
                      backgroundColor: "#F5F5F5",
                      color: "#FF1F00",
                      fontWeight: "600",
                    }}
                    onClick={() =>
                      ArchiveCompany(record?.payment[0]?.company_id?._id)
                    }
                  >
                    Archive
                  </Button>
                </div>
              }
              title="Update Status"
            >
              <button className="tbl-action-btn tbl-action-btn--confirm">
                <EditOutlined />
                Edit
              </button>
            </Popover>
          {record.payment.length > 0 && !record.payment[0].is_payment ? (
              <Popover
                content={
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    <p style={{ color: "#2E3191", fontSize: "12px" }}>
                      Are You Confirm to Approve?
                    </p>
                    <Button
                      style={{ backgroundColor: "green", color: "#fff" }}
                      onClick={() =>
                        AdminApprovePayment(record._id, record.email, record)
                      }
                    >
                      Yes
                    </Button>
                  </div>
                }
                title="Update Status"
              >
                <button className="tbl-action-btn tbl-action-btn--approve">
                  <CheckOutlined />
                  Approve
                </button>
              </Popover>
          ) : record.payment.length > 0 ? (
            <button className="tbl-action-btn tbl-action-btn--approve" disabled={true}>
              <CheckCircleOutlined />
              Approved
            </button>
          ) : null}
        </Space>
      ),
    },
  ];

  return (
    <div className="dataTable">
      <div className="filterMenu">
        <Button className="btn_light_blue" onClick={getArchiveList}>
          Archive
        </Button>
        <Button
          className="add_button"
          onClick={() => SetisModalOpenClients(true)}
        >
          Add New Client
        </Button>
        <Input.Search
          onSearch={(value) => {
            setSearchText(value);
          }}
          onChange={(e) => {
            setSearchText(e.target.value);
          }}
          className="searchField"
          placeholder="Search here..."
        />
      </div>
      <AppTable
        className="dataGrid"
        columns={columns}
        dataSource={contentData}
      />
      <></>
      <AppModal
        title="Assign & Manage Package"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        className="add_pacakge_popup"
      >
        <Form
          name="basic"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          layout="vertical"
          form={form}
          style={{ marginTop: "25px" }}
        >
          <Collapse
            defaultActiveKey={activeKey}
            activeKey={activeKey}
            onChange={setActiveKey}
          >
            {activeTab1 === true && (
              <Panel header="Assign Package 1" key="1">
                {allPackageList && (
                  <Form.Item
                    label="Choose Package"
                    name="package_name"
                    rules={[
                      {
                        required: true,
                        message: "Please choose the package",
                      },
                    ]}
                    className="form_item_blue"
                  >
                    <Select
                      disabled={disabledPacageDropdown ? true : false}
                      onChange={handleChange}
                      options={allPackageList
                        .filter((option: any) => option._id !== packageIdP2) // Filter out the excluded ID
                        .map((option: any) => ({
                          value: option._id,
                          label: option.package,
                        }))}
                      placeholder="Please choose the package"
                    />
                  </Form.Item>
                )}
                <Form.Item
                  label="Contract Duration"
                  name="duration"
                  rules={[
                    {
                      required: true,
                      message: "Please Choose The Package Duration",
                    },
                  ]}
                  className="form_item_blue"
                >
                  <Select
                    onChange={handleChangeDuration}
                    placeholder="Please choose the package duration"
                  >
                    <option value="12months">12 Months</option>
                    <option value="24months">24 Months</option>
                  </Select>
                </Form.Item>
                {/* <Form.Item
                  label={
                    <>
                      Package Amount
                      <i style={{ fontWeight: "normal" }}>
                        (18% GST Tax excluded)
                      </i>
                    </>
                  }
                  name="package_price"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Amount",
                    },
                    {
                      pattern: new RegExp(/^[0-9\b]+$/),
                      message: "Please enter valid number!",
                    },
                  ]}
                  className="form_item_blue"
                >
                  <Input
                    onChange={onChangePackageAmount}
                    placeholder="Please Enter Amount"
                  />
                </Form.Item> */}
                <Form.Item
                  label="Employees (Units)"
                  name="employees"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter the number of employees",
                    },
                    {
                      pattern: new RegExp(/^[0-9\b]+$/),
                      message: "Please enter valid number!",
                    },
                  ]}
                  className="form_item_blue"
                >
                  <Input
                    onChange={onChangeEmployees}
                    placeholder="Please Enter the number of employees"
                  />
                </Form.Item>
                <div className="price_per_person">
                  <Form.Item
                    label={
                      <>
                        Price Per Person
                        <i style={{ fontWeight: "normal" }}>
                          (18% GST Tax excluded)
                        </i>
                      </>
                    }
                    name="unitPrice"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter Amount",
                      },
                      {
                        pattern: new RegExp(/^[0-9\b]+$/),
                        message: "Please enter valid number!",
                      },
                    ]}
                    className="form_item_blue"
                  >
                    <Input
                      onChange={onChangePricePerPerson}
                      placeholder="Please Enter Amount"
                    />
                  </Form.Item>
                  <span className="month"> {paymentDuration} </span>
                </div>

                {isPricePerPerson !== 0 && (
                  <div className="breakdown_wrapper">
                    <h3>Breakdown(s)</h3>
                    <div className="price_box">
                      <h3>Package 1</h3>
                      <ul>
                        <li>
                          <div>
                            <p>
                              {allPackageList &&
                                allPackageList.map((pk: any) => {
                                  return pk._id === packageId ? (
                                    pk.package
                                  ) : (
                                    <></>
                                  );
                                })}{" "}
                              Membership -{" "}
                              {paymentDuration === "12months"
                                ? "12 months"
                                : "24 months"}
                            </p>
                          </div>
                          <div>
                            <p>
                              ₹
                              {Number(
                                packagePricingBreakdown?.packageAmount
                              ).toFixed(2) || 0}
                            </p>
                          </div>
                        </li>
                        {isEmployees !== null && (
                          <li>
                            <div>
                              <p>Unit</p>
                            </div>
                            <div>
                              <p>{isEmployees}</p>
                            </div>
                          </li>
                        )}
                        {isPricePerPerson !== 0 && (
                          <li>
                            <div>
                              <p>Price Per Person</p>
                            </div>
                            <div>
                              <p>₹{Number(isPricePerPerson)?.toFixed(2)}</p>
                            </div>
                          </li>
                        )}

                        <li className="tax_details">
                          <div className="line">
                            <div>
                              <p>+ Taxes/ IGST (18%)</p>
                            </div>
                            <div>
                              <p>
                                ₹
                                {packagePricingBreakdown?.igstTax?.toFixed(2) ||
                                  0}
                              </p>
                            </div>
                          </div>

                          <div
                            className="line tax"
                            style={{ marginTop: "8px" }}
                          >
                            <div className="gray">
                              <p>CGST (9%)</p>
                            </div>
                            <div>
                              <p>
                                ₹
                                {packagePricingBreakdown?.cgstTax?.toFixed(2) ||
                                  0}
                              </p>
                            </div>
                          </div>
                          <div className="line tax">
                            <div className="gray">
                              <p>SGST/UTGST (9%)</p>
                            </div>
                            <div>
                              <p>
                                ₹
                                {packagePricingBreakdown?.sgstTax?.toFixed(2) ||
                                  0}
                              </p>
                            </div>
                          </div>
                        </li>
                        <li className="total_amount border">
                          <div>
                            <p>Total Amount</p>
                          </div>
                          <div>
                            <p>₹{packagePricingBreakdown?.subTotalAmount}</p>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
                {/* <div className="yellow_tip_box">
                  <p style={{ marginBottom: "16px" }}>
                    Enter the <strong>Package Amount </strong> in the form after
                    calculating it manually. For invoicing purposes, please also
                    provide the <strong>Price Per Person, Per Month</strong>{" "}
                    separately.
                  </p>
                  <p>
                    Note: This will not affect the total package amount entered.
                  </p>
                </div> */}
                <h3 style={{ fontSize: "16px", color: "#2E3191", marginTop: "16px" }}>
                  Assign Add-ons
                </h3>
                <CheckboxList
                  preSelectPackages={preSelectPackages}
                  modules={memberModules}
                />
              </Panel>
            )}

            {activeTab2 === true && (
              <Panel header="Assign Package 2" key="2">
                {allPackageList && (
                  <Form.Item
                    label="Choose Package"
                    name="package_name_p2"
                    rules={[
                      { required: true, message: "Please input Package Name!" },
                    ]}
                    className="form_item_blue"
                  >
                    <Select
                      disabled={disabledPacageDropdown ? true : false}
                      onChange={handleChangeP2}
                      options={allPackageList
                        .filter((option: any) => option._id !== packageId) // Filter out the excluded ID
                        .map((option: any) => ({
                          value: option._id,
                          label: option.package,
                        }))}
                      placeholder="Please choose the package"
                    />
                  </Form.Item>
                )}
                <Form.Item
                  label="Contract Duration"
                  name="duration_p2"
                  rules={[
                    {
                      required: true,
                      message: "Please Choose The Package Duration",
                    },
                  ]}
                  className="form_item_blue"
                >
                  <Select
                    onChange={handleChangeDurationP2}
                    placeholder="Please choose the package duration"
                  >
                    <option value="12months">12 Months</option>
                    <option value="24months">24 Months</option>
                  </Select>
                </Form.Item>
                {/* <Form.Item
                  label={
                    <>
                      Package Amount
                      <i style={{ fontWeight: "normal" }}>
                        (18% GST Tax excluded)
                      </i>
                    </>
                  }
                  // label="Package Amount (18% GST Tax excluded)"
                  name="package_price_p2"
                  rules={[
                    { required: true, message: "Please Enter Amount" },
                    {
                      pattern: new RegExp(/^[0-9\b]+$/),
                      message: "Please enter valid number!",
                    },
                  ]}
                  className="form_item_blue"
                >
                  <Input
                    onChange={onChangePackageAmount2}
                    placeholder="Please Enter Amount"
                  />
                </Form.Item> */}
                <Form.Item
                  label="Employees (Units)"
                  name="employees_p2"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter the number of employees",
                    },
                    {
                      pattern: new RegExp(/^[0-9\b]+$/),
                      message: "Please enter valid number!",
                    },
                  ]}
                  className="form_item_blue"
                >
                  <Input
                    onChange={onChangeEmployeesP2}
                    placeholder="Please Enter the number of employees"
                  />
                </Form.Item>
                <div className="price_per_person">
                  <Form.Item
                    label={
                      <>
                        Price Per Person
                        <i style={{ fontWeight: "normal" }}>
                          (18% GST Tax excluded)
                        </i>
                      </>
                    }
                    name="unitPrice_p2"
                    rules={[
                      { required: true, message: "Please Enter Amount" },
                      {
                        pattern: new RegExp(/^[0-9\b]+$/),
                        message: "Please enter valid number!",
                      },
                    ]}
                    className="form_item_blue"
                  >
                    <Input
                      onChange={onChangePricePerPersonP2}
                      placeholder="Please Enter Amount"
                    />
                  </Form.Item>
                  <span className="month"> {paymentDurationP2} </span>
                </div>

                {isPricePerPerson !== 0 && (
                  <div
                    className="breakdown_wrapper"
                    style={{ paddingBottom: "10px" }}
                  >
                    <h3>Breakdown(s)</h3>
                    <div className="price_box">
                      <h3>Package 1</h3>
                      <ul>
                        <li>
                          <div>
                            <p>
                              {allPackageList &&
                                allPackageList.map((pk: any) => {
                                  return pk._id === packageId ? (
                                    pk.package
                                  ) : (
                                    <></>
                                  );
                                })}{" "}
                              Membership -{" "}
                              {paymentDuration === "12months"
                                ? "12 months"
                                : "24 months"}
                            </p>
                          </div>
                          <div>
                            <p>
                              ₹
                              {Number(
                                packagePricingBreakdown?.packageAmount
                              ).toFixed(2) || 0}
                            </p>
                          </div>
                        </li>
                        {isEmployees !== null && (
                          <li>
                            <div>
                              <p>Unit</p>
                            </div>
                            <div>
                              <p>{isEmployees}</p>
                            </div>
                          </li>
                        )}
                        {isPricePerPerson !== 0 && (
                          <li>
                            <div>
                              <p>Price Per Person</p>
                            </div>
                            <div>
                              <p>₹{Number(isPricePerPerson)?.toFixed(2)}</p>
                            </div>
                          </li>
                        )}

                        <li className="tax_details">
                          <div className="line">
                            <div>
                              <p>+ Taxes/ IGST (18%)</p>
                            </div>
                            <div>
                              <p>
                                ₹
                                {packagePricingBreakdown?.igstTax?.toFixed(2) ||
                                  0}
                              </p>
                            </div>
                          </div>

                          <div
                            className="line tax"
                            style={{ marginTop: "8px" }}
                          >
                            <div className="gray">
                              <p>CGST (9%)</p>
                            </div>
                            <div>
                              <p>
                                ₹
                                {packagePricingBreakdown?.cgstTax?.toFixed(2) ||
                                  0}
                              </p>
                            </div>
                          </div>
                          <div className="line tax">
                            <div className="gray">
                              <p>SGST/UTGST (9%)</p>
                            </div>
                            <div>
                              <p>
                                ₹
                                {packagePricingBreakdown?.sgstTax?.toFixed(2) ||
                                  0}
                              </p>
                            </div>
                          </div>
                        </li>
                        <li className="total_amount border">
                          <div>
                            <p>Total Amount</p>
                          </div>
                          <div>
                            <p>₹{packagePricingBreakdown?.subTotalAmount}</p>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
                {isPricePerPersonP2 !== 0 && (
                  <div
                    className="breakdown_wrapper"
                    style={{ paddingTop: "0", border: "0" }}
                  >
                    <div className="price_box">
                      <h3>Package 2</h3>
                      <ul>
                        <li>
                          <div>
                            <p>
                              {allPackageList &&
                                allPackageList.map((pk: any) => {
                                  return pk._id === packageIdP2 ? (
                                    pk.package
                                  ) : (
                                    <></>
                                  );
                                })}{" "}
                              Membership -{" "}
                              {paymentDurationP2 === "6-month"
                                ? "6 months"
                                : "12 months"}
                            </p>
                          </div>
                          <div>
                            <p>
                              ₹
                              {Number(
                                packagePricingBreakdown2?.packageAmount
                              ).toFixed(2) || 0}
                            </p>
                          </div>
                        </li>
                        {isEmployeesP2 !== null && (
                          <li>
                            <div>
                              <p>Unit</p>
                            </div>
                            <div>
                              <p>{isEmployeesP2}</p>
                            </div>
                          </li>
                        )}
                        {isPricePerPersonP2 !== 0 && (
                          <li>
                            <div>
                              <p>Price Per Person</p>
                            </div>
                            <div>
                              <p>₹{Number(isPricePerPersonP2)?.toFixed(2)}</p>
                            </div>
                          </li>
                        )}

                        <li className="tax_details">
                          <div className="line">
                            <div>
                              <p>+ Taxes/ IGST (18%)</p>
                            </div>
                            <div>
                              <p>
                                ₹
                                {packagePricingBreakdown2?.igstTax?.toFixed(
                                  2
                                ) || 0}
                              </p>
                            </div>
                          </div>

                          <div
                            className="line tax"
                            style={{ marginTop: "8px" }}
                          >
                            <div className="gray">
                              <p>CGST (9%)</p>
                            </div>
                            <div>
                              <p>
                                ₹
                                {packagePricingBreakdown2?.cgstTax?.toFixed(
                                  2
                                ) || 0}
                              </p>
                            </div>
                          </div>
                          <div className="line tax">
                            <div className="gray">
                              <p>SGST/UTGST (9%)</p>
                            </div>
                            <div>
                              <p>
                                ₹
                                {packagePricingBreakdown2?.sgstTax?.toFixed(
                                  2
                                ) || 0}
                              </p>
                            </div>
                          </div>
                        </li>
                        <li className="total_amount border">
                          <div>
                            <p>Total Amount</p>
                          </div>
                          <div>
                            <p>₹{packagePricingBreakdown2?.subTotalAmount}</p>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
                <div className="breakdown_subtotal">
                  <div>
                    <p>Subtotal</p>
                  </div>
                  <div>
                    <p>
                      ₹
                      {(
                        parseFloat(
                          packagePricingBreakdown?.subTotalAmount || 0
                        ) +
                        parseFloat(
                          packagePricingBreakdown2?.subTotalAmount || 0
                        )
                      ).toFixed(2)}
                    </p>
                  </div>
                </div>
                {/* <div className="yellow_tip_box">
                  <p style={{ marginBottom: "16px" }}>
                    Enter the <strong>Package Amount </strong> in the form after
                    calculating it manually. For invoicing purposes, please also
                    provide the <strong>Price Per Person, Per Month</strong>{" "}
                    separately.
                  </p>
                  <p>
                    Note: This will not affect the total package amount entered.
                  </p>
                </div> */}
                <CheckboxListP2
                  preSelectPackages={preSelectPackagesP2}
                  modules={memberModules}
                />
              </Panel>
            )}
          </Collapse>

          {/* <div className="breakdown_subtotal">
            <div>
              <p>Subtotal</p>
            </div>
            <div>
              <p>
                ₹
                {(
                  parseFloat(packagePricingBreakdown?.subTotalAmount || 0) +
                  parseFloat(packagePricingBreakdown2?.subTotalAmount || 0)
                ).toFixed(2)}
              </p>
            </div>
          </div> */}
          {!disabledPacageDropdown ? (
            <>
              <div className="verifi_checkbox">
                <Checkbox onChange={VerifiedPackage}></Checkbox>
                <p>I have thoroughly verified all the details.</p>
              </div>
              <Form.Item style={{ marginBottom: "10px" }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={btnDisable ? true : false}
                  className="cn_btn"
                  style={{ margin: "24px auto 0", width: "100%" }}
                >
                  Confirm & Proceed
                </Button>
              </Form.Item>
            </>
          ) : (
            <Form.Item style={{ marginBottom: "10px" }}>
              <Button
                //disabled={btnDisable ? true : false}
                className="cn_btn"
                style={{ margin: "24px auto 0", width: "100%" }}
                type="primary"
                htmlType="submit"
              >
                Update
              </Button>
            </Form.Item>
          )}

          <Form.Item>
            {!anotherPlan && (
              <Button
                style={{
                  margin: "0 auto 0",
                  width: "100%",
                  background: "#F5F5F5",
                  color: "#2E3191",
                  fontSize: "14px",
                  border: "none",
                  height: "46px",
                }}
                onClick={AssignAnotherPlan}
                disabled={isNextPackage ? true : false}
              >
                Assign Another Plan
              </Button>
            )}
          </Form.Item>
        </Form>
      </AppModal>
      <AppModal
        title="Add Client"
        open={isModalOpenClients}
        onOk={handleOkClients}
        onCancel={handleCancelClients}
        className="add_pacakge_popup"
      >
        <Form
          name="normal_login"
          initialValues={{ remember: true }}
          onFinish={onFinishClients}
          form={clientForm}
        >
          <Form.Item
            name="full_name"
            rules={[
              {
                required: true,
                message: "Please Enter Employee Full Name!",
              },
              {
                validator: nameValidation,
              },
            ]}
            style={{ marginBottom: "16px" }}
          >
            <Input
              name="full_name"
              className="input"
              // value={editContent?.full_name}
              // onChange={handleInputChange}
              type="text"
              placeholder="Please Enter Employee Full Name"
            />
          </Form.Item>
          <Form.Item
            name="email"
            rules={[
              {
                required: true,
                type: "email",
                message: "Please enter valid Email!",
              },
            ]}
          >
            <Input
              className="input"
              name="email"
              // onChange={handleInputChange}
              // value={editContent.email}
              placeholder={"Please Enter Employee Email ID"}
            />
          </Form.Item>
          <Form.Item
            name="company"
            rules={[
              {
                required: true,
                message: "Please enter company name!",
              },
            ]}
          >
            <Input
              className="input"
              name="company"
              // onChange={handleInputChange}
              // value={editContent.email}
              placeholder={"Please Enter Company Name "}
            />
          </Form.Item>
          <Form.Item
            name="phone_number"
            className="contact_input"
            rules={[
              {
                required: true,
                message: "Please enter your phone number!",
              },
              {
                pattern: new RegExp(
                  /((\+*)((0[ -]*)*|((91 )*))((\d{12})+|(\d{10})+))|\d{5}([- ]*)\d{6}/
                ),
                message: "Please input your valid phone number!",
              },
            ]}
            style={{ marginBottom: 15 }}
          >
            <Input
              addonBefore={prefixSelector}
              maxLength={10}
              placeholder="Please Enter Your Phone Number"
            />
          </Form.Item>
          <Form.Item style={{ marginBottom: "10px" }}>
            <Button
              type="primary"
              htmlType="submit"
              // disabled={btnDisable ? true : false}
              className="cn_btn"
              style={{ margin: "24px auto 0", width: "100%" }}
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </AppModal>
    </div>
  );
}

export default CommentsDataTable;
